/* *** ENUMS *** */
export enum PaymentMethod {
  FULL_AMOUNT = 'Full amount',
  DEPOSIT = 'Deposit',
  NEXT_PAYMENT = 'Next Payment',
  CUSTOM_AMOUNT = 'Custom Amount'
}

export const paymentMethodMapping = {
  [PaymentMethod.FULL_AMOUNT]: 0,
  [PaymentMethod.DEPOSIT]: 1,
  [PaymentMethod.NEXT_PAYMENT]: 2, // this is FE only (MMB), this value is not implemented on the BE side
  [PaymentMethod.CUSTOM_AMOUNT]: 3 // this is FE only (MMB), this value is not implemented on the BE side
};

/* *** MODELS *** */
export interface PaymentFormValues {
  buildingNameOrNumber?: string;
  companyName?: string;
  street?: string;
  address: string;
  address2: string;
  townCity: string;
  county: string;
  postCode: string;
  country?: string;
  countryIso2?: string;
  discountCode: string;
  paymentMethod: PaymentMethod;
  amount?: string;
  totalOutstandingAmount?: number;
  tradeEmail: string;
  cardholderName: string;
  cardholderEmail?: string;
  contactByPost: boolean;
  cardNumber: string;
  cardExpiryDate: string;
  cvv: string;
  termsAccepted: boolean;
  nameOnCard: string;

  leadCompanyName?: string;
  leadBuildingNameOrNumber?: string;
  leadStreet?: string;
  leadPostCode?: string;
  leadCounty?: string;
  leadTownCity?: string;
  leadCountry?: string;
  leadCountryIso2?: string;
}
